export default __webpack_public_path__ + "static/media/codesandbox.d3edcb5a.svg";